///loader
/*!
 * jQuery Cookie Plugin v1.3
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2011, Klaus Hartl
 * Dual licensed under the MIT or GPL Version 2 licenses.
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.opensource.org/licenses/GPL-2.0
 */
(function ($, document, undefined) {

	var pluses = /\+/g;

	function raw(s) {
		return s;
	}

	function decoded(s) {
		return decodeURIComponent(s.replace(pluses, ' '));
	}

	var config = $.cookie = function (key, value, options) {

		// write
		if (value !== undefined) {
			options = $.extend({}, config.defaults, options);

			if (value === null) {
				options.expires = -1;
			}

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setDate(t.getDate() + days);
			}

			value = config.json ? JSON.stringify(value) : String(value);

			return (document.cookie = [
				encodeURIComponent(key), '=', config.raw ? value : encodeURIComponent(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// read
		var decode = config.raw ? raw : decoded;
		var cookies = document.cookie.split('; ');
		for (var i = 0, l = cookies.length; i < l; i++) {
			var parts = cookies[i].split('=');
			if (decode(parts.shift()) === key) {
				var cookie = decode(parts.join('='));
				return config.json ? JSON.parse(cookie) : cookie;
			}
		}

		return null;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		if ($.cookie(key) !== null) {
			$.cookie(key, null, options);
			return true;
		}
		return false;
	};

})(jQuery, document);
///// THOMAS... A partir de la ligne 205 commence le code pour la gestion de la demande de pret... ne pas l'effacer :-)

$(window).on("load", function(e) {
    $("#wait").fadeOut();
});

$(document).ready(function() {

// cookie

      function pop_up_rgpd(){
      setTimeout(function(){
          $('#alert_cookie').show();
      },2000)
  };

		if($.cookie('rgpd') != 1) {
            pop_up_rgpd();
		};
        $('#accepte').click(function(){ // Si la réponse est OUI
            $.cookie('reponse', '1', { expires: 30 }); // on crée le cookie reponse = 1
            $.cookie('rgpd', '1', { expires: 30 });
        $('#alert_cookie').hide();
function loadTAG() {
   var script = document.createElement('script');
   script.src = 'js/analytics.js';
   var head = document.getElementsByTagName("head")[0];
   head.appendChild(script);
};
loadTAG();
        });

        $('#refuse').click(function(){ // Si la réponse est NON
            $.cookie('reponse', '0', { expires: 30 }); // on crée le cookie reponse = 0
            $.cookie('rgpd', '1', { expires: 30 });
            $('#alert_cookie').hide();
        });
  //});

  checkProListeners()
    // fin Cookie
  $('.down-pdf').addClass('hidden')



////////////// POP-UP
	$('#modal_pop-up').modal({
		dismissible: false
	});

  function pop_up(){
      setTimeout(function(){
          $('#modal_pop-up').modal('open');
      },2000)
  };


////////// COOKIE
 if($.cookie('the_cookie') != 1) { // Si the_cookie n'a pas pour valeur 1 alors on l'initialise et on joue l'appel de la popup
            pop_up();
    };



//	 $(".scroll").click(function() {
////         alert('Cookie détruit');
//		 $.removeCookie('the_cookie');
//	 });
$('#autorisation button').click(function(){
        var index_child = $(this).closest('li').index();

    if(index_child == 0){
        //oui
    $.cookie('the_cookie', '1', { expires: 1 }); // valeur en jour(s) avant expiration du cookie
         $('#modal_pop-up').modal('close');
        }
    if(index_child == 1){
        //non
    $.cookie('the_cookie', '1', { expires: 1 }); // valeur en jour(s) avant expiration du cookie
          $('#modal_pop-up').modal('close');
        }
            });


    $('#autorisation p').text("L’accès est limité aux professionnels de santé, merci de confirmer que vous êtes un professionnel de santé.");
    $('#autorisation p').prepend('<strong>Ce site contient des informations technico-médicales déconseillées au grand public.</strong><br>');


////////////// LOG-USER
    $('#modal_user ul li').click(function(){
        var index_child = $(this).index();
        if(index_child == 0){
        $('#modal_user').removeClass('user_inscription');
        }
        if(index_child == 1){
            $('#modal_user').addClass('user_inscription');
        }
    });
$('#edit-ndeg-rpps').prop("disabled", true);
$('#edit-profession').on('change', function() {
  var val_select =  this.value;
  var val_chir =  "13";
        if(val_select == val_chir){
          $('#edit-ndeg-rpps').prop("disabled", false);
          $('#edit-ndeg-rpps').prop("validate", true);
//            alert('oui');
        }else{

          $('#edit-ndeg-rpps').prop("disabled", true);
          $('#edit-ndeg-rpps').prop("validate", false);
//            alert('non');
        };

    });
//////////////// Masque log panel + affiche log panel

    var timer;
$('#index').on("mousedown",function(){
    timer = setTimeout(function(){
        $('#log-user').css('visibility','visible');
    },1*3000);
}).on("mouseup mouseleave",function(){
    clearTimeout(timer);
});

    //////// Panel Langue
    $("#dropdown-trigger").click(function(ev) {
        $("#lang").fadeOut();
        if ($(this).next().css("display") == "none") {
            $(this).next().fadeIn();
        } else {
            $(this).next().fadeOut();
        }
        ev.stopPropagation();

        $(document).one('click', function() {
            $("#lang").fadeOut();
        });
    });
    ////////////// Hover_menu
//    $('nav footer ul li a').mouseover(function() {
//        $(this).addClass('hover_menu');
//    }).mouseout(function() {
//        $(this).removeClass('hover_menu');
//    });



    $('.sub_trigger').click(function(ev) {
        $('.sub_trigger').closest('li').find('ul').removeClass('sub-active');
        $('.sub_trigger').removeClass('active');
        $(this).closest('li').find('ul').addClass('sub-active');
        $(this).addClass('active');
                ev.stopPropagation();

        $(document).one('click', function() {
        $('.sub_trigger').closest('li').find('ul').removeClass('sub-active');
        $('.sub_trigger').removeClass('active');
        });
    });

    ////////////// hover btn
    $('.outline-btn').mouseover(function() {
        $(this).addClass('btn_hover');
    }).mouseout(function() {
        $(this).removeClass('btn_hover');
    });



    var nb_ul_tabs = $('#produit div ul.tabs li').length;
    if( nb_ul_tabs == 0){ $('#produit #mobile_select').hide();}
    if( nb_ul_tabs == 1){ $('#produit div ul.tabs li').removeClass('l4 m4'); $('#produit div ul.tabs li').addClass('l12 m12');}
    if( nb_ul_tabs == 2){ $('#produit div ul.tabs li').removeClass('l4 m4'); $('#produit div ul.tabs li').addClass('l6 m6');}



//    //// Resize pour collapse sub-menu mobil
//    function size_screen() {
//        var size_screen = $(document).width();
//        if (size_screen <= 800) {
//            $('.sub_trigger').addClass('menu_collapse');
//        } else {
//            $('.sub_trigger').removeClass('menu_collapse');
//        }
//    };
//    size_screen();
//
//    $(window).resize(function() {
//        size_screen();
//    });
//
//    $(window).resize(function() {
//        var size_screen_1 = $(document).width();
//        if (size_screen_1 >= 800) {
//            $('#fade_mobile').fadeIn('slow');
//        } else {
//
//
//        };
//    });
    ////////////////// Collapse menu mobile
//    $('.menu_collapse').click(function() {
//        //remove les collapses
//        $('.menu_collapse').closest('li').find('ul').slideUp();
//        $(this).closest('li').find('ul').slideToggle();
//    });

    /////////////////HAM
$.fn.extend({
    toggleText: function(a, b){
        return this.text(this.text() == b ? a : b);
    }
});
    $('#ham').click(function() {
        $('#fade_mobile').fadeToggle();
        $("#ham i").toggleText('menu', 'clear');
    });


    function indicate() {
        $('#modal_user .indicator').addClass('indicate');
    }
    indicate();


    $('#modal_user .tab').click(function() {
        $('#modal_user .tab').removeClass('indicate');
    });

    ////// Materializcss
    $('.tabs').tabs();
    $('.modal').modal();
    $('.tooltipped').tooltip();
    $('.parallax').parallax();
    $('select').formSelect();
    $('.collapsible').collapsible();
    $('.chips').chips();
    //$('.materialboxed').materialbox();

    ////// SLick
    $('.sliding-img').slick({
        dots: true,
        dotsClass: 'indicate-dot',
        arrows: false,
    });

//    function height_slick() {
//     //   var height_container = $('.set-produit.active').height();
//     //   $('.set-produit').css('min-height', height_container)
//            //        alert(height_container);
//    };
//    height_slick();

    $('#content .tab a').click(function() {
        $('.set-produit').addClass('showing');

        //  $('.sliding-img').slick('destroy');
        $('.sliding-img').slick('slickGoTo', 0);
        //height_slick();

        setTimeout(function() {
            $('.set-produit').removeClass('showing');
            //height_slick();
        }, 500);

        var my_rub = $(this).closest('li').attr('data_triger');
        $('.set-produit').css('display','none');
        $('.set-produit.'+my_rub+'').css('display','block');
        if(my_rub=='rub45'){
            $('#rub8').css('display','block');
        }else{
        }
    });
var numb_item = $('#produit .tabs li.tab').length;
    if(numb_item=='2'){
          $('.tab').removeClass('l4');
          $('.tab').addClass('l6');
        $('#produit .tabs').removeClass('l8').addClass('l6');
    };
       if(numb_item=='3'){
          $('.tab').addClass('m4');
        $('#produit .tabs').removeClass('m10').addClass('m12');
    };
$('.set-produit .card .card-content h3 i').click(function(){
    $(this).closest('h3').closest('.card-content').closest('.card').css('overflow','visible');
});


    /// PDF

    $('h3.activator').click(function() {
        $(this).closest('.card').find('.down-pdf').addClass('vu');
    });
    $('.quitte i').click(function() {
        $(this).closest('.card').find('.down-pdf').removeClass('vu');
    });

    //// form change
$('#form-pret .input-field label').addClass('active');

    $('.compte .input-field').keyup(function() {
        $('.outline-btn:disabled').removeAttr('disabled');
        $('.outline-btn').click(function() {
            $(this).attr("disabled", "disabled");
        });

    });
    $('.form-item-profession label').addClass('active');
    $('#create_compte form .webform-button--submit').click(function(){
        $('#create_compte form label').hide();
    });
    $('#create_compte label').addClass('active');
    $('.js-form-item-professions label').addClass('active');


    ////Mobile select & rubrique


    var selected_item = $('.compte aside ul li.active').text();
    $('#mobile_select').text(selected_item);

	var select_active = $('#produit ul.no-float .active').text();
	$('#mobile_select').text(select_active);

	function listscreen() {
        if ($(window).width() < 800) {
            $('.compte aside ul li').click(function() {
                selected_item = $(this).text();
                $('#mobile_select').text(selected_item);
                $('.compte aside ul').hide();
            });
            $('#mobile_select').click(function() {
                $('.compte aside ul').fadeIn('fast');
            });
        } else {}
    };
		function listscreen2() {
        if ($(window).width() < 800) {
            $('#produit ul.no-float li').click(function() {
                select_active = $(this).text();
                $('#mobile_select').text(select_active);
                $('#produit ul.no-float').hide();
            });
            $('#mobile_select').click(function() {

                $('#produit ul.no-float').fadeIn('fast');
            });
        } else {}
    };
    listscreen();
    listscreen2();

    /// filter mon compte
    $('.compte aside ul li').click(function() {
        $('.compte aside ul li').removeClass('active');
        $(this).addClass('active');
        var recup = $(this).attr('data_triger');
        $('.compte section article').hide();
        $('.compte section article[data-filter=' + recup + ']').fadeIn();
    });


/////////// Stick Nav
    //window.onscroll = function() {stickfunction()};
    //var navbar = document.getElementById("stick");
    //var sticklisten = document.getElementById("content");
    //var sticky = sticklisten.offsetTop;
    //function stickfunction() {
    //  if (window.pageYOffset >= sticky) {
    //    navbar.classList.add("sticky");
    //  } else {
    //    navbar.classList.remove("sticky");
    //  }
    //};

    ////// textarea demande de pret
    //    $('#form-pret article a').click(function(){
    //        var text_hidden = $(this).closest('article').find('span').html();
    //        var text_hidden = $(this).closest('article').find('span').html();
    //        $(this).closest('article').find('textarea').val(text_hidden)
    //        $(this).closest('article').find('textarea').show();
    //
    //    });

    //////////// Valeur
    $('#valeur aside ul li').click(function() {
        var data = $(this).attr('data-valeur');
        $('#valeur aside ul li').removeClass('active');
        $(this).addClass('active');
        $('.valeur').hide();
        $('.valeur.' + data + '').fadeIn(500, "swing");
    });

    var style_perso = {
        'position': 'relative',
        'height': '500px',
        'height': '50vh'
    };
    $('#adresse-map').closest("aside").css(style_perso);

    /////////////// collapse formation
    $('#formation article').click(function() {
        $('#formation article').removeClass('active');
        $(this).addClass('active');
    });

    // ////////////// Relax
    // var rellax = new Rellax('.rellax', {
    //     // center: true
    //     callback: function(position) {
    //         // callback every position change
    //         console.log(position);
    //     }
    // });


}); /////DOC ready

const checkProListeners=()=>{

  for(let button of document.querySelectorAll('[data-role="check-pro"]')){

    button.addEventListener('click',(e)=>{

      if("yes" == button.getAttribute('data-value')){
        $.cookie('est_pro', 'true', { expires: 1 })
        $('.down-pdf').removeClass('hidden')
      }
      else  if("no" == button.getAttribute('data-value')){
        $.cookie('est_pro', 'false', { expires: 1 })
        $('.down-pdf').addClass('hidden')
      }

    })

  }

}
